export default (state: any, {hasError}: any) => ({
  ...state,
  businessProfile: {
    ...state.businessProfile,
    hasError,
  },
});
